/**
 * SAYM: "Load more" for the collection / search grid.
 * Fetches the next page through the Section Rendering API and appends its cards.
 * Without JS the button is a normal link to the next page.
 */
class SaymLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.saym-load-more__button');
    this.button?.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = async (event) => {
    const { nextUrl, sectionId } = this.dataset;
    if (!nextUrl || !sectionId) return;

    event.preventDefault();
    this.setAttribute('aria-busy', 'true');
    this.button?.setAttribute('aria-disabled', 'true');

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString(), { cache: 'no-store' });
      if (!response.ok) throw new Error(`Load more failed: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = this.closest('#ResultsList')?.querySelector('.product-grid');
      const newItems = [...doc.querySelectorAll('.product-grid > .product-grid__item')];
      if (!grid || newItems.length === 0) throw new Error('No products found on next page');

      grid.append(...newItems);

      // Move focus to the first new product for keyboard and screen reader users
      newItems[0]?.querySelector('a')?.focus({ preventScroll: true });

      const nextControl = doc.querySelector('saym-load-more');
      if (nextControl) {
        this.replaceWith(nextControl);
      } else {
        this.remove();
      }
    } catch (error) {
      // Fall back to a normal page load of the next page
      window.location.href = nextUrl;
    }
  };
}

if (!customElements.get('saym-load-more')) {
  customElements.define('saym-load-more', SaymLoadMore);
}
